module.exports = __webpack_public_path__ + "img/guanghua-tab1.ab94657d.png";